import { createFileRoute, notFound } from '@tanstack/react-router';

import { client } from '@@api/client';
import { isApiError } from '@@api/errorHandler';
import { HTTP_STATUS_CODES } from '@@constants/http';
import { useSettingsStore } from '@@scripts/store/settings/useSettingsStore';

import { PreviewMetadata } from '../../-components/PreviewMetadata';

export const Route = createFileRoute('/_authenticated/preview/metadata/$metadataId/{-$tenantId}')({
    context: ({ params }) => ({
        metadataQuery: client.metadata.metadata.get.queryOptions({
            params: { id: Number(params.metadataId) },
            query: { includePreviewUrl: true },
        }),
    }),
    loader: async ({ abortController, context }) => {
        const response = await context.queryClient
            .query({ ...context.metadataQuery, staleTime: 'static' })
            // An unknown item shows the 404 page. For other errors, the preview shows its own message.
            .catch((error: unknown) => {
                if (isApiError(error) && error.status === HTTP_STATUS_CODES.NOT_FOUND) {
                    throw notFound();
                }
            });

        // The queries the page builds when it renders send the metadata's language, unless
        // another preview is opening
        if (response?.body.locale && !abortController.signal.aborted) {
            useSettingsStore.getState().setMetadataContentLocale(response.body.locale);
        }
    },
    component: PreviewMetadata,
});
